import { Checkbox, FormControl, InputLabel } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { _T } from 'appI18n';
import range from 'lodash/range';
import React from 'react';
import Select from '../Select';
import useStyles from './styles';
function TouristPickerCategory({ label, count, onAdd, onRemove }) {
    const classes = useStyles();
    return (React.createElement(Grid, { container: true, alignItems: "center" },
        React.createElement(Grid, { item: true, xs: 6 },
            React.createElement(Typography, { variant: "h5", component: "span" }, label)),
        React.createElement(Grid, { item: true, xs: 6 },
            React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "space-between" },
                React.createElement(IconButton, { className: classes.countBtn, onClick: onRemove },
                    React.createElement(RemoveIcon, null)),
                React.createElement(Typography, { variant: "h4", component: "span" }, count),
                React.createElement(IconButton, { className: classes.countBtn, onClick: onAdd },
                    React.createElement(AddIcon, null))))));
}
export function TouristPicker({ adultCount, childAges, onChange }) {
    const classes = useStyles();
    const handleAddAdult = () => adultCount < 10 && onChange(adultCount + 1, childAges);
    const handleRemoveAdult = () => adultCount > 1 && onChange(adultCount - 1, childAges);
    const handleAddChild = () => childAges.length < 4 && onChange(adultCount, [...childAges, 0]);
    const handleRemoveChild = () => childAges.length > 0 && onChange(Math.max(adultCount, 0), childAges.slice(0, childAges.length - 1));
    const handleChildAgeChange = (childIndex, e) => {
        const ages = [...childAges];
        ages[childIndex] = parseInt(e.target.value);
        onChange(adultCount, ages);
    };
    return React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.categories },
            React.createElement(TouristPickerCategory, { label: _T.COMMON_ADULTS, count: adultCount, onAdd: handleAddAdult, onRemove: handleRemoveAdult }),
            React.createElement(TouristPickerCategory, { label: _T.COMMON_CHILDREN, count: childAges.length, onAdd: handleAddChild, onRemove: handleRemoveChild })),
        React.createElement("div", { className: classes.childAges }, childAges.map((x, i) => React.createElement(Select, { label: `${_T.COMMON_CHILD_AGE} ${i + 1}`, value: x, key: i, fullWidth: true, onChange: handleChildAgeChange.bind(null, i) }, range(0, Number.parseInt(_T.CHILD_MAX_AGE) + 1).map(age => React.createElement("option", { value: age, key: age }, age))))));
}
export function TouristPickerWithPlace({ adultCount, childAges, onChange }) {
    const classes = useStyles();
    const handleAddAdult = () => adultCount < 10 && onChange(adultCount + 1, childAges);
    const handleRemoveAdult = () => adultCount > 1 && onChange(adultCount - 1, childAges);
    const handleAddChild = () => childAges.length < 4 && onChange(adultCount, [...childAges, { age: 0, withPlace: false }]);
    const handleRemoveChild = () => childAges.length > 0 && onChange(Math.max(adultCount, 0), childAges.slice(0, childAges.length - 1));
    const handleChildAgeChange = (childIndex, e) => {
        const ages = [...childAges];
        ages[childIndex].age = parseInt(e.target.value);
        onChange(adultCount, ages);
    };
    const handleChildPlaceChange = (childIndex, e) => {
        const ages = [...childAges];
        ages[childIndex].withPlace = e.target.checked;
        onChange(adultCount, ages);
    };
    return React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.categories },
            React.createElement(TouristPickerCategory, { label: _T.COMMON_ADULTS, count: adultCount, onAdd: handleAddAdult, onRemove: handleRemoveAdult }),
            React.createElement(TouristPickerCategory, { label: _T.COMMON_CHILDREN, count: childAges.length, onAdd: handleAddChild, onRemove: handleRemoveChild })),
        React.createElement("div", { className: classes.childAges }, childAges.map((x, i) => React.createElement("div", { className: "input-group w-100" },
            React.createElement("div", { className: "p-0" },
                React.createElement(Select, { label: `${_T.COMMON_CHILD_AGE} ${i + 1}`, value: x.age, key: i, fullWidth: true, onChange: handleChildAgeChange.bind(null, i) }, range(0, Number.parseInt(_T.CHILD_MAX_AGE) + 1).map(age => React.createElement("option", { value: age, key: age }, age)))),
            React.createElement("span", { className: "input-group-addon" },
                React.createElement(FormControl, { variant: "filled", fullWidth: true },
                    React.createElement(InputLabel, { variant: "standard", shrink: true }, _T.COMMON_CHILD_PLACE),
                    React.createElement(Checkbox, { value: x.withPlace, checked: x.withPlace, key: i, onChange: handleChildPlaceChange.bind(null, i) })))))));
}
